import styled from 'styled-components';
import media from '../../../../styles/media.style';
import { BLACK, WHITE } from '../../../../styles/variables.style';

const STEP_COLOR = '#d7d7d7';
const HAIR_CARE_COLOR = '#859db4';
const SCALP_CARE_COLOR = '#89ab99';
export const HAIR_CARE = 'HAIR_CARE';
export const SCALP_CARE = 'SCALP_CARE';

export const Background = styled.div`
  width: 100vw;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  position: relative;
  width: 100vw;
  box-sizing: border-box;
  padding-top: 120px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 40px;

  ${media.tabletP`
    padding-top: 220px;
  `};
`;

export const ScrollArea = styled.div`
  overflow-y: scroll;
  height: 100%;
  max-height: 100%;
`;

export const SubTitle = styled.p`
  text-align: center;
  font-size: 13px;
  position: relative;
  color: #000;
  padding: 0 0 0 0;
  margin: 30px 0 10px 0;

  ${media.tabletP`
    font-size: 16px;
    margin: 60px 0 20px 0;
  `};

  + h1 {
    font-size: 16px;
    padding-top: 0;
    margin: 60px 0 20px 0;
    margin-top: 0;
  }
`;

export const Title = styled.h1`
  position: relative;
  margin: 0;
  text-align: center;
  font-size: 18px;
  color: #000;
  overflow: hidden;
  padding: 0 40px;

  ${media.tabletP`
    padding: 0;
    margin-bottom: 20px;
    font-size: 30px;
  `};
`;

export const Contents = styled.div`
  position: relative;
  margin: 0 auto 20px auto;
  width: 100%;
  max-width: 728px;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
`;

export const HowToTab = styled.div`
  width: 80%;
  margin: 0 auto 30px auto;
  display: flex;

  ${media.tabletP`
    width: 600px;
    margin: 0 auto 40px auto;
 `};
`;

export const HowToTabItem = styled.div`
  width: 50%;
  height: 50px;
  padding: 0 30px 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  font-size: 11px;
  color: #000;

  ${media.tabletP`
    padding: 0 20px;
    font-size: 14px;
    border-right: solid 1px #c4c6c8;
  `};

  .image {
    display: inline-block;
    margin-right: 10px;
  }

  &:after,
  &:before {
    content: '';
    display: block;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 1px;
    background: #bbbbbb;

    ${media.tabletP`
      right: 20px;
    `};
  }

  &:after {
    transform: translateY(-50%) rotate(90deg);
  }

  &.active {
    background: #989ea2;
    color: #fff;

    &:after,
    &:before {
      background: #fff;
    }
  }
`;

export const PowerContainerWrap = styled.div`
  margin: 20px auto 0 auto;

  ${media.tabletP`
    width: 300px;
    margin: 0 auto;
  `};
`;

export const PowerProgram = styled.div`
  display: flex;
  text-align: center;
  font-size: 12px;
  color: #000;
  margin-top: 20px;
  justify-content: left;
  padding: 0 40px;

  ${media.tabletP`
    font-size: 14px;
    padding: 0;
    width: 300px;
    margin: 20px auto 0 auto;
  `};

  .title {
    font-weight: bold;
  }
  .caption {
    margin-left: 5px;
  }
`;

export const PowerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  padding: 0 40px;

  &:last-child {
    margin-bottom: 0;
  }

  ${media.tabletP`
    padding: 0;
    margin-bottom: 5px;
    margin-left: 10px;
  `};
`;

export const PowerTitle = styled.div`
  font-size: 12px;
  color: #000;
  width: 100px;

  &.small {
    font-size: 12px;
  }

  ${media.tabletP`
    font-size: 14px;
    width: 120px;
  `};
`;

export const PowerValueContainer = styled.div`
  flex: 1;
  flex-grow: 1;
  margin-left: -15px;
  align-items: center;

  .powerbar {
    margin-left: 0px;
    margin-top: 3px;
    margin-bottom: 0;
    display: flex;
  }
  .powerbar li {
    list-style-type: none;
    width: 80%;
    font-size: 5px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    color: ${STEP_COLOR};
  }

  .powerbar li:before {
    width: 10px;
    height: 10px;
    content: '';
    line-height: 10px;
    background-color: ${STEP_COLOR};
    display: block;
    text-align: center;
    margin: 0 auto 0 auto;
    border-radius: 50%;
  }

  .powerbar li:after {
    width: 100%;
    height: 2px;
    content: '';
    position: absolute;
    background-color: ${STEP_COLOR};
    top: 4px;
    left: -50%;
    margin-left: 5px;
  }
  .powerbar li:first-child:after {
    content: none;
  }
  .powerbar li.active {
    color: ${({ theme }) =>
      theme === HAIR_CARE ? HAIR_CARE_COLOR : theme === SCALP_CARE ? SCALP_CARE_COLOR : HAIR_CARE_COLOR};
  }
  .powerbar li.active:before {
    background-color: ${({ theme }) =>
      theme === HAIR_CARE ? HAIR_CARE_COLOR : theme === SCALP_CARE ? SCALP_CARE_COLOR : HAIR_CARE_COLOR};
  }
  .powerbar li.active:after {
    background-color: ${({ theme }) =>
      theme === HAIR_CARE ? HAIR_CARE_COLOR : theme === SCALP_CARE ? SCALP_CARE_COLOR : HAIR_CARE_COLOR};
  }
`;

export const SwipeContainer = styled.div`
  overflow: hidden;
  padding-top: 30px;
`;

export const SwiperButtonPrev = styled.button`
  top: 60% !important;
  left: 0 !important;
  width: 40px !important;
  height: 100px !important;
  overflow: hidden !important;
  text-align: left !important;
  text-indent: -9999px !important;
  display: block !important;
  border: none !important;
  background-color: transparent !important;
  appearance: none !important;
  outline: none !important;
  background-size: 14px 25px !important;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAwCAMAAAA4o5qsAAAAolBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8ELnaCAAAANXRSTlMA9e/8+ToI5cQpH+nea0c0MSUaFhEN8ezZ1IiBcltDPuLPzcm+r5F5X1VRSi64taWbmWVkTiNB8/4AAADHSURBVDjLldJJEoJAEERRG1pREBRnVJyV0dm6/9UM9/WJMLdvmb9Fu6cAnbM8UJ4gN7mAXFFOstRl2pXVvzI5SgZykLUu472EIAnJaOG+UXJd/L6bkthCl3hnS116nq1ITKRLHZiNLsO52eoycGZtXdqOAxKKM4CsltLttNimZKsGy+Q4IVvLocH2Y7JQErSXJCOy3F2gpW7fJysarLS7mOxjPbTKeD2yyAQ12cbMh2TbmXItBAEZQXxglOwv9MBEaJ5Fi0/+F2HSEI9tJjIyAAAAAElFTkSuQmCC') !important;

  ${media.tabletP`
    top: 65% !important;
    width: 70px !important;
    background-size: 27px 44px !important; 
  `};
`;

export const SwiperButtonNext = styled.button`
  top: 60% !important;
  right: 0 !important;
  width: 40px !important;
  height: 100px !important;
  overflow: hidden !important;
  text-align: left !important;
  text-indent: -9999px !important;
  display: block !important;
  border: none !important;
  background-color: transparent !important;
  appearance: none !important;
  outline: none !important;
  background-size: 14px 25px !important;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAwCAMAAAA4o5qsAAAAn1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8Kd3m4AAAANHRSTlMA+fXw7Dsy5cRcKQvp3kUlGg8G2dSYi2pIPy4eAeLPzcm+r4V/eXRuZFVRTTYhFxUSuLWlohVy7gAAAMxJREFUOMt900cWglAMQFHyEQEFbIgo9t5Bzf7X5gbyyPSOcvLiVbuBB5NJ2CMrXYKWuWRBNnedLlng+88WC8i6nTZzc7JF4jKyXuhKskEoD7SV3MleqdzIqlRisuGkxXK9kr1znZHVa72QNRs9k422ekKL9EjWj/TQYgWej1Z4YhCBT4lxfJxs6egJHkJylxU81U3Sly2xpBXJZGjLVUlmmr9tuei6tuWsm8aWk25Hthw1Ajlo1Lel0J0ty0I/IFP9jkn2tngsXvwj+QNRUxC0C6gEIwAAAABJRU5ErkJggg==') !important;

  ${media.tabletP`
    top: 65% !important;
    width: 70px !important;
    background-size: 27px 44px !important; 
  `};
`;

export const SwipeParallax = styled.div`
  position: absolute;
  bottom: 30px;
  height: 150px;

  ${media.tabletP`
    bottom: 60px;
    height: 300px;
  `};
  ul {
    position: absolute;
    top: 0;
    left: 0;
    list-style: none;
    width: 100%;
    height: 150px;
    filter: blur(3px);
    opacity: 0.3;
    ${media.tabletP`
      height: 300px;
    `};
    li {
      position: absolute;
      top: 0;
      img {
        display: block;
        margin: 0 auto;
        width: 200px;
        height: 150px;

        ${media.tabletP`
          width: 400px;
          height: 300px;
        `};
      }
    }
  }
`;

export const SwipeContainerInner = styled.div`
  display: block;
  width: 250px;
  height: 187px;
  margin: 0 auto;
  position: relative;

  ${media.tabletP`
    width: 500px;
    height: 375px;
  `};

  .recommend {
    width: 75px;
    height: 75px;
    border-radius: 1000px;
    position: absolute;
    top: -25px;
    right: -10px;
    background-color: #cfd9e2;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 10px;
    font-weight: bold;

    ${media.tabletP`
      top: -20px;
      right: -20px;
      font-size: 12px;
      width: 100px;
      height: 100px;
    `};
  }
`;

export const RadioGroup = styled.div`
  display: flex;
`;

export const RadioItem = styled.div`
  display: block;

  input {
    display: none;
    + label {
      display: flex;
      width: 100%;
      line-height: 1.4;
      vertical-align: middle;
      border: solid 1px #cccccc;
      padding: 0 40px 0 10px;
      height: 70px;
      position: relative;
      font-size: 16px;
      color: #000;
      align-items: center;
      ${media.tabletP`
        height: 86px;
        padding: 0 60px 0 10px;
      `};

      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        right: 15px;
        z-index: 1;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        border: 1px solid #989ea2;
        border-radius: 1000px;

        ${media.tabletP`
          right: 20px;
        `};
      }

      .image {
        width: 46px;
        height: 46px;
        border-radius: 1000px;
        overflow: hidden;
      }

      .info {
        width: calc(100% - 46px);
        margin-left: 10px;

        .title {
          margin-bottom: 3px;
          font-size: 11px;

          ${media.tabletP`
            font-size: 14px;
          `};
        }

        .description {
          font-size: 9px;

          ${media.tabletP`
            font-size: 8px;
          `};
        }
      }
    }

    &:checked {
      + label {
        background-color: rgba(152, 158, 162, 0.15);
        border: 1px solid #9ba1a5;

        &:before {
          border: 1px solid #989ea2;
          background: #989ea2;
        }

        &:after {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          right: 21px;
          z-index: 1;
          transform: translateY(-50%);
          width: 8px;
          height: 8px;
          background: #fff;
          border-radius: 1000px;

          ${media.tabletP`
            right: 26px;
          `};
        }
      }
    }
  }
`;

export const ItemChoice = styled.div`
  width: 80%;
  margin: 0 auto 30px auto;

  ${media.tabletP`
    width: 600px;
    margin: 0 auto 40px auto;
 `};
`;
export const ItemChoiceTitle = styled.div`
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  color: #000;
  margin-bottom: 10px;

  ${media.tabletP`
    font-size: 14px;
  `};
`;
export const ItemChoiceContent = styled.div`
  display: block;

  ${media.tabletP`
    display: flex;
  `};
`;
export const ItemChoiceItem = styled.label`
  position: relative;
  display: table;
  width: 100%;
  height: 70px;
  border: solid 1px #bbb;
  margin-bottom: 15px;

  ${media.tabletP`
    margin-right: 20px;
    width: calc(50% - 10px);
  `};

  &:last-child {
    margin-right: 0;
  }
  &:after,
  &:before {
    content: '';
    display: block;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 1px;
    background: #bbbbbb;

    ${media.tabletP`
      right: 20px;
    `};
  }
  &:after {
    transform: translateY(-50%) rotate(90deg);
  }
  > .image {
    width: 65px;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
  > .text {
    display: table-cell;
    padding-left: 5px;
    padding-right: 30px;
    vertical-align: middle;
    text-align: left;
    font-size: 10px;
    color: #000;

    ${media.tabletP`
      font-size: 13px;
    `};
  }
`;

export const FregranceChoice = styled.div`
  width: 80%;
  margin: 0 auto 30px auto;

  ${media.tabletP`
    width: 600px;
  `};
`;
export const FregranceChoiceTitle = styled.div`
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  color: #000;
  margin-bottom: 10px;

  ${media.tabletP`
    font-size: 14px;
  `};
`;
export const FregranceChoiceContent = styled.div`
  display: block;

  ${media.tabletP`
    display: flex;
  `};
`;
export const FregranceChoiceItem = styled.label`
  display: block;
  margin-bottom: 15px;

  ${media.tabletP`
    margin-right: 20px;
    width: calc(50% - 10px);
  `};

  &:last-child {
    margin-right: 0;
  }
`;

export const CardBackground = styled.div`
  display: none;
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.8);
  &.active {
    display: block;
  }
`;

export const CardContainer = styled.div`
  display: none;
  position: fixed;
  z-index: 2000;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  padding: 0 5% 20px 5%;
  &.active {
    display: block;
  }
`;

export const CardContent = styled.div`
  margin: 0 auto;
  width: 100%;

  ${media.tabletP`
    width: 100%;
    max-width: 728px;
    min-width: 400px;
  `};
`;

export const CardBody = styled.div`
  background-color: ${WHITE};
  box-shadow: 0px 10px 28.2px 1.8px rgba(0, 0, 0, 0.2);
  max-height: calc(100vh - 150px);
  overflow-y: auto;

  ${media.tabletP`
    max-height: calc(100vh - 280px);
  `};
`;

export const CardHeader = styled.div`
  text-align: left;
  cursor: pointer;
  color: ${BLACK};
  font-size: 14px;
  text-align: right;
  background-color: rgba(0, 0, 0, 0);

  > .closeButton {
    display: block;
    width: 50px;
    height: 50px;
    margin-left: auto;
    margin-right: 0;
    &:after,
    &:before {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
      content: '';
      display: block;
      width: 20px;
      height: 2px;
      background: ${BLACK};

      ${media.tabletP`
        transform: translate(-50%, -50%) rotate(45deg);
        width: 15px;
        height: 1px;
      `};
    }

    &:after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
`;

export const CardCloseButton = styled.span`
  position: relative;
`;

export const Navi = styled.div`
  width: 100%;
  padding: 40px 0;

  .navi__button {
    display: block;
    border: none;
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    background: #959b9f;
    font-size: 13px;
    font-weight: bold;

    ${media.tabletP`
      width: 340px;
      margin: 0 auto;
      font-size: 16px;
      height: 60px;
      line-height: 60px;
    `};
  }
`;

export const AttentionIcon = styled.span`
  display: inline-block;
  background-color: #d30207;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  line-height: 16px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  font-size: 12px;
  margin-left: 10px;
`;

export const AttentionText = styled.div`
  display: block;
  text-align: center;
  padding: 0 40px;

  .attention-text__text {
    margin-bottom: 20px;
    padding: 12px 20px 10px 20px;
    display: inline-block;
    font-size: 13px;
    color: #d30207;
    border: solid 1px #d30207;
    line-height: 1.5em;

    ${media.tabletP`
      font-size: 16px;
      padding: 7px 30px 5px 30px;
      margin-bottom: 40px;
    `};
  }
`;

export const FlickTitle = styled.h1`
  height: 3em;
  position: relative;
  margin: 0;
  text-align: center;
  font-size: 18px;
  color: #000;
  overflow: hidden;
  padding: 0 40px;

  ${media.tabletP`
    height: 3em;
    padding: 0;
    margin-bottom: 20px;
    font-size: 30px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/Common/Common.style.js